// 平台管理员url前缀
export const platformUserPrefix = '/platformUser'

// 租户管理员url前缀
export const tenantUserPrefix = '/tenantUser'

export const business = '/research-business-backend'

export const platform = '/research-platform-backend'



// WEBPACK FOOTER //
// ./src/api/common/index.js